import { siteStats } from "@/mocks/site";

export default function StatsBand() {
  return (
    <section className="bg-background-100 border-b border-background-200">
      <div className="max-w-shell mx-auto px-4 md:px-6 py-8 grid grid-cols-2 lg:grid-cols-4 gap-6">
        {siteStats.map((item) => (
          <div key={item.label} className="flex flex-col gap-1.5">
            <span className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              {item.value}
              <span className="ml-1 text-sm font-medium text-primary-600">{item.unit}</span>
            </span>
            <span className="text-xs md:text-sm text-foreground-500">{item.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
}